import { HekateDisplayForm } from 'www-shared';
import { Ref, toRefs, watch } from 'vue';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class UnifiedSignupProgressProfile extends CommonPreFilledProgressiveProfile {
  // eslint-disable-next-line class-methods-use-this
  public realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>
  }): void {
    super.realtimeBranchModifications({ formDefinition }); // handles edu country/region, etc...
    const { screenNumber } = toRefs(formDefinition.value);
    watch(screenNumber, () => {
      // eslint-disable-next-line no-console
      console.log('Screen number', screenNumber.value);
    });
  }
}
